import React from 'react';
import SurveyScaling from '../../QuestionType/surveyScaling';
import { FormProvider, useForm } from 'react-hook-form';

const ScalingResult = ({ result }) => {
  const methods = useForm();

  return (
    <FormProvider {...methods}>
      <SurveyScaling defaultValues={result[0]} isDisable={true} />
    </FormProvider>
  );
};

export default ScalingResult;
